module.exports = __webpack_public_path__ + "static/media/hamburger_icon.b5098bdc.png";